import { useRef } from "react";

/**
 * useDragScroll
 * Shared between LeadManagement and Quality.
 * Replaces the copy-pasted tableScrollRef + three mouse handler functions
 * in both files.
 *
 * Usage:
 *   const { scrollRef, onMouseDown, onMouseMove, onMouseUp } = useDragScroll();
 *
 *   <div
 *     ref={scrollRef}
 *     className={styles.tableScroll}
 *     style={{ overflowX: "scroll", cursor: "grab", userSelect: "none" }}
 *     onMouseDown={onMouseDown}
 *     onMouseMove={onMouseMove}
 *     onMouseUp={onMouseUp}
 *     onMouseLeave={onMouseUp}
 *   >
 */
export function useDragScroll() {
  const scrollRef = useRef(null);
  const isDragging = useRef(false);
  const dragStartX = useRef(0);
  const scrollStartX = useRef(0);

  const onMouseDown = (e) => {
    if (!scrollRef.current) return;
    isDragging.current = true;
    dragStartX.current = e.clientX;
    scrollStartX.current = scrollRef.current.scrollLeft;
    scrollRef.current.style.cursor = "grabbing";
  };

  const onMouseMove = (e) => {
    if (!isDragging.current || !scrollRef.current) return;
    const dx = e.clientX - dragStartX.current;
    scrollRef.current.scrollLeft = scrollStartX.current - dx;
  };

  const onMouseUp = () => {
    isDragging.current = false;
    if (scrollRef.current) {
      scrollRef.current.style.cursor = "grab";
    }
  };

  return { scrollRef, onMouseDown, onMouseMove, onMouseUp };
}